import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/js/setRem.js";
import 'animate.css';

createApp(App).use(router).mount("#app");
